import type { ReactNode } from 'react';

interface RescanFooterProps {
  /** Scan-progress element (ScanProgress / DiscoveryScanProgress), or falsy when idle. */
  progress?: ReactNode;
  /** Informational notice (e.g. the Feature page's 24h gate); null when none. */
  notice?: string | null;
  noticeTestId?: string;
  /** Hard error message; null when none. */
  error?: string | null;
  errorTestId?: string;
  /** The ScanFooterLine element (or null when the caller suppresses it). */
  footer: ReactNode;
}

/**
 * Shared re-scan tail for the drill-down pages: the in-flight scan-progress block,
 * the notice/error badges, and the "Last scan · Re-scan" footer line — stacked with
 * the page's `mb-lg` spacing. The divergent bits (which progress component, notice
 * text, whether the footer renders) are injected by the caller, not branched here.
 */
export function RescanFooter({ progress, notice, noticeTestId, error, errorTestId, footer }: RescanFooterProps) {
  return (
    <>
      {progress && <div className="mb-lg">{progress}</div>}
      {notice && <p className="badge badge-info mb-lg" data-testid={noticeTestId}>{notice}</p>}
      {error && <p className="badge badge-error mb-lg" data-testid={errorTestId}>Rescan error: {error}</p>}
      {footer}
    </>
  );
}
